import { useEffect } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { sdk } from 'src/utilities/sdk';
import { AsyncTaskStatus, useAsyncTask } from 'src/utilities/useAsyncTask';

export interface UseUpdateGroup {
  updateGroup: (employeeId: string) => void;
}

export interface UseUpdateGroupProps {
  corpId: string;
  groupId: string;
  onSuccess: () => void;
}

export const useUpdateGroup = ({
  corpId,
  groupId,
  onSuccess,
}: UseUpdateGroupProps): UseUpdateGroup => {
  const { status: asyncTaskStatus, startAsyncTask } = useAsyncTask();

  useEffect(() => {
    if (asyncTaskStatus === AsyncTaskStatus.COMPLETE) {
      onSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asyncTaskStatus]);

  async function updateGroup(employeeId: string): Promise<void> {
    const payload = {
      diners_to_add: [employeeId],
      diners_to_remove: [],
    };
    try {
      await startAsyncTask(() => {
        return sdk.http.put(
          `/corp-admin/${corpId}/groups/v2/${groupId}/diners`,
          payload
        );
      });
    } catch (error) {
      pushErrorFromAPI(error, {
        fallbackMessage: 'The group has not been updated. Try again.',
      });
    }
  }

  return {
    updateGroup,
  };
};
